
/* CAQA Depth engine. Transform-only, interruptible, honours reduced motion and the motion switch. Needs gsap, ScrollTrigger and Lenis (loaded as theme assets); degrades to a static page without them. */
(function () {
  'use strict';
  var doc = document.documentElement, body = document.body;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var stored = null; try { stored = localStorage.getItem('cq-motion'); } catch (e) {}
  var on = stored ? stored === 'on' : !reduce;
  var lenis = null, built = false;

  /* family launcher */
  var cqf = document.getElementById('cqf');
  if (cqf) {
    var ov = document.getElementById('cqf-overlay'), q = document.getElementById('cqf-q');
    function open() { ov.hidden = false; body.classList.add('cqf-open'); setTimeout(function () { if (q) q.focus(); }, 60); }
    function close() { ov.hidden = true; body.classList.remove('cqf-open'); }
    cqf.querySelectorAll('[data-cqf-open]').forEach(function (b) { b.addEventListener('click', open); });
    cqf.querySelectorAll('[data-cqf-close]').forEach(function (b) { b.addEventListener('click', close); });
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ov.hidden) close(); });
    var tabs = cqf.querySelectorAll('.cqf-tab'), panes = cqf.querySelectorAll('.cqf-pane'), pn = cqf.querySelector('.cqf-panes');
    tabs.forEach(function (t) { t.addEventListener('click', function () {
      tabs.forEach(function (x) { x.classList.toggle('on', x === t); x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
      panes.forEach(function (p) { p.classList.toggle('on', p.dataset.g === t.dataset.g); });
    }); });
    if (q) q.addEventListener('input', function () {
      var v = q.value.trim().toLowerCase(), any = false;
      pn.classList.toggle('f', !!v);
      cqf.querySelectorAll('.cqf-card').forEach(function (c) { var hide = !!v && c.dataset.t.indexOf(v) < 0; c.classList.toggle('h', hide); if (!hide) any = true; });
      panes.forEach(function (p) { p.classList.toggle('e', !!v && !p.querySelector('.cqf-card:not(.h)')); });
      cqf.querySelector('.cqf-empty').hidden = !(v && !any);
    });
    var here = cqf.querySelector('.cqf-here b'), host = location.hostname.replace(/^www\./, ''), cur = null;
    cqf.querySelectorAll('.cqf-card').forEach(function (c) { try { if (!cur && new URL(c.href).hostname.replace(/^www\./, '') === host) cur = c; } catch (e) {} });
    if (cur && here) { here.textContent = cur.querySelector('b').textContent; cur.classList.add('cqf-card--here'); }
  }

  /* CAQA mega menu: click to open on touch and keyboard, hover on desktop, Escape closes */
  var mega = document.getElementById('cq-mega');
  if (mega) {
    var burger = mega.querySelector('.cq-mega__burger');
    burger.addEventListener('click', function () { var o = mega.classList.toggle('open'); burger.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    mega.querySelectorAll('.has-panel > .cq-mega__top').forEach(function (t) {
      t.addEventListener('click', function () { var li = t.parentNode, was = li.classList.contains('open'); mega.querySelectorAll('.has-panel.open').forEach(function (o) { o.classList.remove('open'); o.querySelector('.cq-mega__top').setAttribute('aria-expanded', 'false'); }); if (!was) { li.classList.add('open'); t.setAttribute('aria-expanded', 'true'); } });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { mega.classList.remove('open'); mega.querySelectorAll('.has-panel.open').forEach(function (o) { o.classList.remove('open'); }); } });
    document.addEventListener('click', function (e) { if (!mega.contains(e.target)) mega.querySelectorAll('.has-panel.open').forEach(function (o) { o.classList.remove('open'); }); });
    var path = location.pathname.replace(/\/$/, '') || '/';
    mega.querySelectorAll('a.cq-mega__top').forEach(function (a) { if ((a.getAttribute('href') || '').replace(/\/$/, '') === path) a.setAttribute('aria-current', 'page'); });
  }

  /* people modal */
  var modal = document.getElementById('cq-modal');
  if (modal) {
    var mimg = modal.querySelector('img'), mname = modal.querySelector('h3'), mrole = modal.querySelector('.cq-sub'), mtext = modal.querySelector('.cq-modal__text');
    document.querySelectorAll('.cq-person[data-name]').forEach(function (p) { p.addEventListener('click', function () {
      mname.textContent = p.dataset.name; mrole.textContent = p.dataset.role; mtext.innerHTML = p.dataset.text || '';
      if (p.dataset.image) { mimg.src = p.dataset.image; mimg.hidden = false; } else { mimg.hidden = true; }
      modal.classList.add('on'); body.classList.add('cqf-open');
    }); });
    function mclose() { modal.classList.remove('on'); body.classList.remove('cqf-open'); }
    modal.querySelector('.cq-modal__close').addEventListener('click', mclose);
    modal.addEventListener('click', function (e) { if (e.target === modal) mclose(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') mclose(); });
  }

  /* calendar: sort upcoming sessions by the date in the title */
  var rail = document.querySelector('.cq-rail__track');
  if (rail) {
    var months = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
    function when(s) { var m = /(\d{1,2})(?:st|nd|rd|th)?\s+([A-Za-z]{3})[A-Za-z]*\s+(\d{4})/.exec(s || ''); return m ? new Date(+m[3], months[m[2].toLowerCase()] || 0, +m[1]).getTime() : 9e15; }
    var items = Array.prototype.slice.call(rail.children);
    items.sort(function (a, b) { return when(a.dataset.date) - when(b.dataset.date); });
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var shown = 0;
    items.forEach(function (it) { var t = when(it.dataset.date); if (t < today.getTime() && t !== 9e15) { it.remove(); return; } rail.appendChild(it); shown++; });
    var empty = document.querySelector('.cq-rail__empty'); if (empty) empty.hidden = shown > 0;
    var count = document.querySelector('[data-cq-rail-count]'); if (count) count.textContent = shown;
  }

  /* motion switch */
  var btn = document.getElementById('cq-motion');
  function label() { if (btn) btn.querySelector('span').textContent = on ? 'Motion on' : 'Motion off'; doc.setAttribute('data-cq-motion', on ? 'on' : 'off'); }
  label();
  if (btn) btn.addEventListener('click', function () { on = !on; try { localStorage.setItem('cq-motion', on ? 'on' : 'off'); } catch (e) {} label(); if (on) build(); else teardown(); });

  var progress = document.querySelector('.cq-progress');
  window.addEventListener('scroll', function () { if (!progress) return; var h = doc.scrollHeight - innerHeight; progress.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, scrollY / h) : 0) + ')'; }, { passive: true });

  function teardown() {
    if (window.ScrollTrigger) ScrollTrigger.getAll().forEach(function (t) { t.kill(); });
    if (window.gsap) gsap.set('.cq-plane, [data-cq-reveal], .cq-planes__card, .cq-rail__track, .cq-page, .cq-field__row, .cq-carousel__track, .cq-stack__card, .cq-stage__world', { clearProps: 'all' });
    if (lenis) { lenis.destroy(); lenis = null; }
    built = false;
  }

  function build() {
    if (built || !on || !window.gsap || !window.ScrollTrigger) return;
    built = true;
    gsap.registerPlugin(ScrollTrigger);
    if (window.Lenis && !lenis) {
      lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      gsap.ticker.lagSmoothing(0);
    }
    var mm = gsap.matchMedia();
    var desk = '(min-width: 901px)';

    /* reveal: content is visible at rest; a short lift plays as it enters */
    document.querySelectorAll('[data-cq-reveal]').forEach(function (el) {
      gsap.from(el, { y: 36, opacity: 0, duration: .9, ease: 'power3.out', immediateRender: false, scrollTrigger: { trigger: el, start: 'top 90%', once: true } });
    });

    /* stage: the lockup planes separate in depth as the visitor scrolls, and lean with the pointer */
    var stage = document.querySelector('.cq-stage');
    if (stage) {
      var planes = stage.querySelectorAll('.cq-plane'), world = stage.querySelector('.cq-stage__world');
      gsap.from(planes, { y: function (i, el) { return 70 * +el.dataset.depth + 20; }, opacity: 0, duration: 1.2, ease: 'power3.out', stagger: .08, delay: .1 });
      gsap.from(stage.querySelectorAll('.cq-stage__copy > *'), { y: 24, opacity: 0, duration: .9, ease: 'power3.out', stagger: .08, delay: .2 });
      mm.add(desk, function () {
        planes.forEach(function (p) {
          var d = +p.dataset.depth;
          gsap.to(p, { y: -240 * d, z: 320 * d, scale: 1 + .25 * d, rotateX: -6 * d, ease: 'none', scrollTrigger: { trigger: stage, start: 'top top', end: 'bottom top', scrub: .6 } });
        });
        gsap.to(stage.querySelector('.cq-stage__copy'), { y: -80, opacity: .2, ease: 'none', scrollTrigger: { trigger: stage, start: 'top top', end: 'bottom top', scrub: .6 } });
        var rx = gsap.quickTo(world, 'rotateX', { duration: .7, ease: 'power2.out' }), ry = gsap.quickTo(world, 'rotateY', { duration: .7, ease: 'power2.out' });
        stage.addEventListener('pointermove', function (e) { var r = stage.getBoundingClientRect(); ry(((e.clientX - r.left) / r.width - .5) * 16); rx(-((e.clientY - r.top) / r.height - .5) * 12); });
        stage.addEventListener('pointerleave', function () { rx(0); ry(0); });
      });
    }

    /* divisions: ten planes you move through */
    var planesSec = document.querySelector('.cq-planes');
    if (planesSec) mm.add(desk, function () {
      var cards = planesSec.querySelectorAll('.cq-planes__card'), dots = planesSec.querySelectorAll('.cq-planes__rail span'), n = cards.length;
      cards.forEach(function (c, i) { gsap.set(c, { z: -160 * i, y: 26 * i, scale: 1 - .05 * i, opacity: i < 4 ? 1 - i * .18 : 0, zIndex: n - i }); });
      var tl = gsap.timeline({ scrollTrigger: { trigger: planesSec.querySelector('.cq-planes__stage'), start: 'top 90px', end: '+=' + (n * 70) + '%', pin: true, scrub: .5, onUpdate: function (st) { var k = Math.min(n - 1, Math.floor(st.progress * n)); dots.forEach(function (d, j) { d.classList.toggle('on', j === k); }); } } });
      cards.forEach(function (c, i) {
        if (i > 0) tl.to(c, { z: 0, y: 0, scale: 1, opacity: 1, duration: 1, ease: 'none' }, i - 1);
        cards.forEach(function (o, j) { if (j > i) tl.to(o, { z: -160 * (j - i - 1), y: 26 * (j - i - 1), scale: 1 - .05 * (j - i - 1), opacity: (j - i - 1) < 4 ? 1 - (j - i - 1) * .18 : 0, duration: 1, ease: 'none' }, i); });
        if (i < n - 1) tl.to(c, { x: '-115%', rotateY: -12, opacity: 0, duration: 1, ease: 'power1.in' }, i);
      });
      return function () { gsap.set(cards, { clearProps: 'all' }); };
    });

    /* people: each row of the field drifts at its own speed, cards lean to the pointer */
    document.querySelectorAll('.cq-field__grid').forEach(function (grid) {
      mm.add(desk, function () {
        var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').length || 7, speeds = [1, .55, .8, .4];
        grid.querySelectorAll('.cq-person').forEach(function (c, i) { var sp = speeds[Math.floor(i / cols) % 4]; gsap.fromTo(c, { y: 50 * sp }, { y: -50 * sp, ease: 'none', scrollTrigger: { trigger: grid, start: 'top bottom', end: 'bottom top', scrub: .8 } }); });
      });
    });
    mm.add(desk, function () {
      document.querySelectorAll('.cq-person').forEach(function (p) {
        var rx = gsap.quickTo(p, 'rotateX', { duration: .5 }), ry = gsap.quickTo(p, 'rotateY', { duration: .5 });
        p.addEventListener('pointermove', function (e) { var r = p.getBoundingClientRect(); ry(((e.clientX - r.left) / r.width - .5) * 14); rx(-((e.clientY - r.top) / r.height - .5) * 14); });
        p.addEventListener('pointerleave', function () { rx(0); ry(0); });
      });
    });

    /* calendar: the rail recedes into the page, sessions approach as you scroll */
    var railSec = document.querySelector('.cq-rail');
    if (railSec) mm.add(desk, function () {
      var items = railSec.querySelectorAll('.cq-rail__item');
      items.forEach(function (it, i) { gsap.fromTo(it, { z: -120 - i * 40, opacity: .35, rotateX: 8 }, { z: 0, opacity: 1, rotateX: 0, ease: 'none', scrollTrigger: { trigger: it, start: 'top 95%', end: 'top 55%', scrub: .6 } }); });
    });

    /* awards: cards stack, the one beneath settles back */
    var stack = document.querySelectorAll('.cq-stack__card');
    if (stack.length) mm.add(desk, function () {
      stack.forEach(function (c, i) { if (i < stack.length - 1) gsap.to(c, { scale: .94, opacity: .55, ease: 'none', scrollTrigger: { trigger: stack[i + 1], start: 'top 80%', end: 'top 30%', scrub: true } }); });
    });

    /* mastheads: pages turn open */
    document.querySelectorAll('.cq-page').forEach(function (pg, i) {
      mm.add(desk, function () { gsap.fromTo(pg, { rotateY: -48, x: 60, opacity: 0 }, { rotateY: 0, x: 0, opacity: 1, ease: 'power2.out', scrollTrigger: { trigger: pg, start: 'top 92%', end: 'top 50%', scrub: .5 } }); });
    });

    /* voices: a horizontal carousel driven by vertical scroll */
    var car = document.querySelector('.cq-carousel');
    if (car) mm.add(desk, function () {
      var track = car.querySelector('.cq-carousel__track');
      var dist = function () { return Math.max(0, track.scrollWidth - car.clientWidth); };
      gsap.to(track, { x: function () { return -dist(); }, ease: 'none', scrollTrigger: { trigger: car, start: 'top 70%', end: function () { return '+=' + (dist() + 200); }, scrub: .8, invalidateOnRefresh: true } });
    });

    ScrollTrigger.refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
  window.addEventListener('load', function () { if (window.ScrollTrigger) ScrollTrigger.refresh(); });
})();
